import {
  BarPlot,
  ChartsTooltip,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  MarkPlot,
  ResponsiveChartContainer,
} from "@mui/x-charts";
import { t } from "i18next";
import React, { useEffect, useState, useMemo } from "react";

const TaskLineChart = ({ dataBar, labelChart }) => {
  const [dataLabel, setDataLabel] = useState([]);
  const [dataObj, setDataObj] = useState({});

  useEffect(() => {
    if (dataBar?.labels) {
      setDataLabel(dataBar.labels);
    }
  }, [dataBar?.labels]);

  useEffect(() => {
    if (dataBar?.objects) {
      setDataObj(dataBar.objects);
    }
  }, [dataBar?.objects]);

  const dataSetBar = dataLabel.map((label) => {
    const dato = dataObj?.find((item) => item.name === label);
    return dato ? dato : { name: label, value1: 0, value2: 0 };
  });

  const availableKeys = Object.keys(dataSetBar[0] || {});

  const allSeries = [
    {
      type: "bar",
      dataKey: "value1",
      label: "Effort Stimato",
      color: "#9572a2",
      bar: "Analisi Effort",
    },
    {
      type: "bar",
      dataKey: "value2",
      label: "Effort Effettivo",
      color: "#7f7f7f",
      bar: "Analisi Effort",
    },
  ];

  const filteredSeries = allSeries.filter(
    (series) =>
      availableKeys.includes(series.dataKey) && series.bar === labelChart
  );

  // Calcolo mediana per ogni label (verticalmente tra le serie)
  const datasetWithMedian = useMemo(() => {
    return dataSetBar.map((item) => {
      const values = filteredSeries
        .map((s) => item[s.dataKey] || 0)
        .sort((a, b) => a - b);
      let median = 0;
      const mid = Math.floor(values.length / 2);
      if (values.length > 0) {
        median =
          values.length % 2 !== 0
            ? values[mid]
            : (values[mid - 1] + values[mid]) / 2;
      }
      return {
        ...item,
        median,
      };
    });
  }, [dataSetBar, filteredSeries]);

  const medianSeries = {
    type: "line",
    dataKey: "median",
    label: "Mediana",
    color: "#d2d2d2",
    bar: labelChart,
  };

  return (
    <div>
      <p className="text-2xl font-bold m-0 ">
        Riepilogo: <span className="text-primary">{labelChart}</span>
      </p>
      <div className="w-full flex justify-center">
        <ResponsiveChartContainer
          xAxis={[
            {
              scaleType: "band",
              id: "labels",
              data: dataLabel.map((label) => t(label)),
              categoryGapRatio: 0.5,
            },
          ]}
          yAxis={[
            {
              id: "main",
              min: 0,
              max: Math.max(
                ...datasetWithMedian.flatMap((item) =>
                  [...filteredSeries, medianSeries].map(
                    (s) => item[s.dataKey] || 0
                  )
                )
              ),
            },
          ]}
          dataset={datasetWithMedian}
          series={[
            ...filteredSeries.map((s) => ({
              ...s,
              yAxisId: "main",
              id: s.dataKey,
            })),
            { ...medianSeries, yAxisId: "main", id: medianSeries.dataKey },
          ]}
          height={600}
        >
          <BarPlot borderRadius={100} />
          <LinePlot />
          <MarkPlot />
          <ChartsXAxis axisId="labels" />
          <ChartsYAxis axisId="main" />
          <ChartsTooltip />
        </ResponsiveChartContainer>
      </div>
    </div>
  );
};

export default TaskLineChart;
